/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../Configuration';

class RestServiceProvider {
    setResourceUrl(resourceUrl) {
        this.resourceUrl = resourceUrl;
    }

    setParamDefaults(paramDefaults) {
        this.paramDefaults = paramDefaults;
    }

    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        throw new Error('A REST service provider does not overwrite the getServiceInstance method.');
    }

    getGetConfig(url) {
        return {
            method: 'GET',
            transformResponse: (data, headers, status) => (status >= 300) ? {} : angular.fromJson(data)
        };
    }

    getSaveConfig(url) {
        return {
            method: 'POST',
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : angular.fromJson(data)
        };
    }

    getUpdateConfig(url) {
        return {
            method: 'PUT',
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : angular.fromJson(data)
        };
    }

    getPatchConfig(url) {
        return {
            method: 'PATCH',
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : angular.fromJson(data)
        };
    }


    getSearchConfig(url) {
        return {
            url: url + Configuration.SEARCH_PATH,
            method: 'POST',
            isArray: false,
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? {} : angular.fromJson(data)
        };
    }

    getFindConfig(url) {
        return {
            url: url + Configuration.FIND_PATH,
            method: 'POST',
            isArray: true,
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? [] : angular.fromJson(data)
        };
    }

    getFindLightConfig(url) {
        return {
            url: url + Configuration.FIND_LIGHT_PATH,
            method: 'POST',
            isArray: true,
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? [] : angular.fromJson(data)
        };
    }

    getDeleteConfig(url) {
        return {
            method: 'DELETE',
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403) || (status === 204))
                    ? null : angular.fromJson(data)
        };
    }

    getSaveAndUploadConfig(url) {
        const saveConfig = this.getSaveConfig(url);
        saveConfig['transformRequest'] = angular.identity;
        saveConfig['headers'] = {
            'Content-Type': undefined
        };
        return saveConfig;
    }

    getUpdateAndUploadConfig(url) {
        const updateConfig = this.getUpdateConfig(url);
        updateConfig['transformRequest'] = angular.identity;
        updateConfig['headers'] = {
            'Content-Type': undefined
        };
        return updateConfig;
    }

    getCountConfig(url) {
        return {
            url: url + Configuration.COUNT_PATH,
            method: 'POST',
            isArray: false,
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : {value: data}
        };
    }

    getConfig() {
        return {
            get: this.getGetConfig(this.resourceUrl),
            save: this.getSaveConfig(this.resourceUrl),
            update: this.getUpdateConfig(this.resourceUrl),
            patch: this.getPatchConfig(this.resourceUrl),
            search: this.getSearchConfig(this.resourceUrl),
            find: this.getFindConfig(this.resourceUrl),
            findLight : this.getFindLightConfig(this.resourceUrl),
            delete: this.getDeleteConfig(this.resourceUrl),
            saveAndUpload: this.getSaveAndUploadConfig(this.resourceUrl),
            updateAndUpload: this.getUpdateAndUploadConfig(this.resourceUrl),
            count: this.getCountConfig(this.resourceUrl)
        };
    }

    /** @ngInject */
    $get($q, $resource, $httpParamSerializerJQLike, $log) {
        $log.debug('REST service mapped to: ' + this.resourceUrl);
        return this.getServiceInstance($q, $resource(this.resourceUrl, this.paramDefaults, this.getConfig()),
            $httpParamSerializerJQLike, $log);
    }
}

export { RestServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/RestServiceProvider.js